import { useState, type ReactNode } from 'react';

import {
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@radix-ui/react-dropdown-menu';
import { useNavigate } from 'react-router-dom';

import { Dialog, DialogContent, DialogTrigger } from '@/components/ui/dialog';
import { DropdownMenu, DropdownMenuItem } from '@/components/ui/dropdown-menu';
import { stringToColour } from '@/utils/tools';

import './auth-status.css';
import { useAuth } from './authContext';

export const AuthStatus = () => {
  const { username, isAuthenticated, signout } = useAuth();
  const navigate = useNavigate();

  const [dialogContent, setDialogContent] = useState<
    ReactNode | false
  >(false);

  const handleSubmit = () => {
    if (
      !confirm('Are you sure you want to log out of your current session ?')
    ) {
      return;
    }
    signout();
    navigate('/login', { replace: true });
  };

  const showDetails = () => {
    setDialogContent(
      <div className="flex p-4 justify-center items-center min-w-64 min-h-64 gap-12">
        <span
          className="auth-miniature flex justify-center items-center"
          style={{
            backgroundColor: stringToColour(username ?? '..'),
          }}
        >
          {username?.slice(0, 2)}
        </span>
        <p>{username}</p>
      </div>,
    );
  };

  return (
    <div className="flex justify-end">
      {!isAuthenticated ? (
        <p>You are not logged in.</p>
      ) : (
        <Dialog>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <button
                className="auth-miniature"
                style={{
                  backgroundColor: stringToColour(username ?? '..'),
                }}
              >
                {username?.slice(0, 2)}
              </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent className="bg-background">
              <DropdownMenuItem onSelect={handleSubmit}>
                Sign out
              </DropdownMenuItem>
              <DialogTrigger asChild>
                <DropdownMenuItem onSelect={showDetails}>
                  My account
                </DropdownMenuItem>
              </DialogTrigger>
            </DropdownMenuContent>
          </DropdownMenu>
          <DialogContent>{dialogContent}</DialogContent>
        </Dialog>
      )}
    </div>
  );
}
